/*
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-07-12 20:02:40
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-19 11:22:13
 * @FilePath: \partner.chaoyongtuan.com\src\api\selectionDecoration.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '@/utils/request';
import { AjaxMethod } from '@/utils/dataMap';

//获取集合页列表
export const productGatherList = params => {
	return request({
		url: '/api/product-center-tpl/product-gather-list',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//轮播图添加
export const bannerAdd = params => {
	return request({
		url: '/api/product-center-tpl/banner-add',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//轮播图列表
export const bannerList = params => {
	return request({
		url: '/api/product-center-tpl/banner-list',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//集合页添加
export const addGatherPage = params => {
	return request({
		url: '/api/product-center-tpl/add-gather-page',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//集合页编辑
export const updateGatherPage = params => {
	return request({
		url: '/api/product-center-tpl/update-gather-page',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//修改集合页状态
export const setGatherPage = data => {
	return request({
		url: '/api/product-center-tpl/set-gather-page',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//修改金刚区状态
export const setIcons = data => {
	return request({
		url: '/api/product-center-tpl/set-icons',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//修改轮播图状态
export const setBanner = data => {
	return request({
		url: '/api/product-center-tpl/set-banner',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//修改橱窗状态
export const setShowCase = data => {
	return request({
		url: '/api/product-center-tpl/set-show-case',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//获取橱窗列表
export const showCaseList = params => {
	return request({
		url: '/api/product-center-tpl/show-case-list',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//金刚区添加
export const iconsAdd = data => {
	return request({
		url: '/api/product-center-tpl/icons-add',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//修改金刚区
export const updateIcons = data => {
	return request({
		url: '/api/product-center-tpl/update-icons',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//集合页删除
export const delGatherPage = params => {
	return request({
		url: '/api/product-center-tpl/del-gather-page',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//金刚区删除
export const delIcons = params => {
	return request({
		url: '/api/product-center-tpl/del-icons',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//轮播图删除
export const delBanner = params => {
	return request({
		url: '/api/product-center-tpl/del-banner',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//修改橱窗1
export const updateShowCase = data => {
	return request({
		url: '/api/product-center-tpl/update-show-case',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//修改橱窗2
export const updateShowCaseTow = data => {
	return request({
		url: '/api/product-center-tpl/update-show-case-tow',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//金刚区列表
export const iconsList = data => {
	return request({
		url: '/api/product-center-tpl/icons-list',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//修改轮播图
export const bannerUpdate = data => {
	return request({
		url: '/api/product-center-tpl/update-banner',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//修改商品组
export const setSortOrder = data => {
	return request({
		url: '/api/product-group/set-sort-order',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//修改选项卡状态
export const setTpl = params => {
	return request({
		url: '/api/product-center-tpl/set-tpl',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//金刚区排序
export const setOrderIcons = params => {
	return request({
		url: '/api/product-center-tpl/set-order-icons',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//banner排序
export const setOrderBanner = params => {
	return request({
		url: '/api/product-center-tpl/set-order-banner',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//获取小程序tpl 二维码
export const tplQrUrl = data => {
	return request({
		url: '/api/product-center-tpl/tpl-qr-url',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
